import React, { useEffect, useRef, useState } from "react";

export const Header = (props) => {
  const textRef = useRef(null);
  const [fontSize, setFontSize] = useState(120); // Initial font size in px

  // Function to split text into two parts
  const splitText = (text) => {
    if (!text) return { part1: "Loading", part2: "" };
    const splitWord = "use";
    const parts = text.split(splitWord);

    if (parts.length > 1) {
      return {
        part1: parts[0].trim(),
        part2: splitWord + " " + parts.slice(1).join(splitWord).trim(),
      };
    } else {
      const words = text.split(" ");
      const midPoint = Math.ceil(words.length / 2);

      return {
        part1: words.slice(0, midPoint).join(" "),
        part2: words.slice(midPoint).join(" "),
      };
    }
  };

  const textParts = splitText(props.data?.paragraph);

  // Dynamically adjust font size
  useEffect(() => {
    const resizeText = () => {
      const el = textRef.current;
      if (!el) return;

      let currentFontSize = 120;
      el.style.fontSize = currentFontSize + "px";

      while (el.scrollWidth > el.offsetWidth && currentFontSize > 10) {
        currentFontSize--;
        el.style.fontSize = currentFontSize + "px";
      }

      setFontSize(currentFontSize);
    };

    resizeText();
    window.addEventListener("resize", resizeText);
    return () => window.removeEventListener("resize", resizeText);
  }, [props.data?.title]);

  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="intro-text">
          <h1
            ref={textRef}
            style={{
              fontSize: `${fontSize}px`,
              whiteSpace: "nowrap",
              overflow: "hidden",
              maxWidth: "55%",
              position: "absolute",
              bottom: "20px",
              left: "20px",
            }}
            className="responsive-title"
          >
            {props.data ? (
              <>
                <span className="title-part">Discover</span>
                <span className="line-break"> </span>
                <span className="title-part">Priori</span>
              </>
            ) : (
              "Loading"
            )}
          </h1>

            <p>
              <span className="text-part-1">{textParts.part1}</span>
              {textParts.part2 && (
                <span className="text-part-2"> {textParts.part2}</span>
              )}
            </p>
          </div>
        </div>
      </div>
    </header>
  );
};
